<template>
  <tm-auto-size-panel class="mb-4">
    <template v-slot:dropdown-activator>
      <tm-button>
        <tm-icon
          name="more_vert"
          left
        />
        <span>{{ $t('common.more') }}</span>
      </tm-button>
    </template>

    <tm-auto-size-panel-item-button
      v-for="i in 4"
      :key="i"
      :loading="true"
    />
  </tm-auto-size-panel>
  <tm-skeleton-details-table />
</template>

<script setup lang="ts">
import TmSkeletonDetailsTable from '@/components/shared/skeletons/TmSkeletonDetailsTable.vue'
import TmAutoSizePanel from '@/components/shared/autoSize/TmAutoSizePanel.vue'
import TmAutoSizePanelItemButton from '@/components/shared/autoSize/panel/TmAutoSizePanelItemButton.vue'
import TmButton from '@/components/shared/TmButton.vue'
import TmIcon from '@/components/shared/TmIcon.vue'
</script>
